const STORAGE_KEY = 'APP_VERSION';
const META_URL = '/meta.json';

export function readStoredAppVersion() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) {
      return '';
    }
    return JSON.parse(raw);
  } catch {
    return '';
  }
}

export function writeStoredAppVersion(version) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(version));
}

async function fetchServerVersion() {
  const response = await fetch(META_URL, { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`meta.json responded with ${response.status}`);
  }
  const meta = await response.json();
  return meta.version;
}

export async function applyAppVersionUpdate(serverVersion) {
  if ('caches' in window) {
    const cacheKeys = await window.caches.keys();
    await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
  }

  writeStoredAppVersion(serverVersion);
  window.location.replace(window.location.href);
}

export async function evaluateAppVersion() {
  const serverVersion = await fetchServerVersion();
  const storedVersion = readStoredAppVersion();

  if (!storedVersion) {
    writeStoredAppVersion(serverVersion);
    return { isLatestVersion: true, serverVersion };
  }

  if (storedVersion !== serverVersion) {
    return { isLatestVersion: false, serverVersion };
  }

  return { isLatestVersion: true, serverVersion };
}
